/* tslint:disable */

/**
 */
export class Export {
    year?: string;
    image?: string;
    link?: string;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/export.ts